.phoneNumber {
  font: "Roboto", sans-serif;
}

.phoneInfo {
  font: "Roboto", sans-serif;
}
